// removed by extract-text-webpack-plugin
module.exports = {"container":"ContentHeader__container___21Fe5","title":"ContentHeader__title___1maLr","icon":"ContentHeader__icon___3LKF3","toggle-navigation":"ContentHeader__toggle-navigation___1yGry","button-back":"ContentHeader__button-back___2skt-","icon-prev":"ContentHeader__icon-prev___bNhR_"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/ContentHeader/ContentHeader.scss
// module id = 938
// module chunks = 0